import React from 'react';

export default function DesktopBlock({ blockType, ...props }) {
  const Component = require(`./blocks/${blockType}`).Desktop;

  return <Component {...props} />;
}
